import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ConfirmCancelData } from './confirm-cancel-data';

@Component({
  selector: 'pnd-confirm-cancel',
  templateUrl: './confirm-cancel.component.html',
  styleUrls: ['./confirm-cancel.component.scss'],
  host: { class: 'pnd-ConfirmCancel' },
})
export class ConfirmCancelComponent {
  title: string;
  content: SafeHtml;
  cancelButtonTitle: string;
  confirmButtonTitle: string;

  constructor(@Inject(MAT_DIALOG_DATA) private data: ConfirmCancelData, private sanitizer: DomSanitizer) {
    this.title = data.heading;
    this.content = this.sanitizer.bypassSecurityTrustHtml(data.body);
    this.cancelButtonTitle = data.cancelButtonTitle;
    this.confirmButtonTitle = data.confirmButtonTitle;
  }
}
